import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment as ENV} from '@environment/environment';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PrayRequestService {
  private API = `${ENV.soaApiBaseUrl}Pray`;

  constructor(private http: HttpClient) {
  }

  prayRequest(uid: string, peticion: string): Observable<any> {
    const body = {
      EnlacePlusID: uid,
      Peticion: peticion
    };
    return this.http.post(this.API, body);
  }
}
